import { Form, Typography } from 'antd';
import styles from './TotalCashToCloseTable.module.scss';
import TotalCashToCloseCol from '../TotalCashToCloseCol';
import { EnumReportTypes } from '../../../../../types/reports';
import { useContextReports } from '../../../../../context/reports';

const TotalCashToCloseTable = () => {
  const { report } = useContextReports();

  const form = Form.useFormInstance()

  const loans = Form.useWatch('loans', form);
  const downPaymentActive = form?.getFieldValue(['tableView', 'downPayment', 'active']);
  const closingCostTimelineActive = form?.getFieldValue(['reportView', 'closingCostsEstimates', 'active']);

  const isRefinance = report?.reportType === EnumReportTypes.refinance;

  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableHeadCol}>
        <div className={styles.tableHeadCell}>
          <Typography.Title level={4} className="color-gray8">
            Total Cash To Close
          </Typography.Title>
        </div>
        {downPaymentActive && (
          <p className={styles.tableCell}>
            <strong className={styles.tableCellTitle}>Down Payment</strong>
          </p>
        )}
        <p className={styles.tableCell}>
          <strong className={styles.tableCellTitle}>Closing Costs</strong>
        </p>
        {closingCostTimelineActive && (
          <p className={styles.tableCell}>
            <strong className={styles.tableCellTitle}>Earnest Money Deposit</strong>
          </p>
        )}
        {isRefinance && (
          <p
            className={styles.tableCell}
            style={{
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center'
            }}
          >
            <strong className={styles.tableCellTitle}>Existing Loan Payoff</strong>
            <p className={styles.tableCellInfoText}>Included in loan amount</p>
          </p>
        )}
        <p className={styles.tableCell} style={{ borderTop: '2px solid var(--color-border)' }}>
          <strong className={styles.tableCellTitle}>Total Cash To Close</strong>
        </p>
      </div>
      <div className={styles.tableColsContainer}>
        {loans?.length > 0 && loans?.map((loan: any, index: number) => {
          if (loans?.[index]?.hidden) {
            return null;
          }

          return <TotalCashToCloseCol key={loan.id} loan={loan} index={index} />
        })}
      </div>
    </div>
  )
}

export default TotalCashToCloseTable;
